export default {
  title: {
    header: 'Bei wîse up anmelden',
    text: 'Sie können sich mit einem WKIS-Konto oder mit einem bestehenden Altkonto anmelden.',
    password_btn: 'Anmelden mit Altkonto',
  },

  form: {
    email: 'E-mail',
    password: 'Passwort',
    btn_submit: 'Einloggen',
    text: 'Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an, wenn Sie ein Altkonto besitzen.',
    sign_in_btn: 'Anmelden',
    divider: 'oder',
  },

  links: {
    forgot_pass: 'Passwort vergessen?',
    sign_up: 'Jetzt erstellen!',
    sign_up_text: 'Noch kein Konto?',
    marketing_site: {
      main_page: 'wise-up.at',
      faq: 'FAQs',
      agb: 'AGBs',
      barrierefreiheit: 'Barrierefreiheit',
      legal_info: 'Impressum',
      data_use: 'Datenschutz',
      contact: 'Kontakt',
    },
  },
}
